module.exports = __webpack_public_path__ + "static/img/unsubscribe.a312fd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/unsubscribe.png
// module id = oRL4
// module chunks = 0